var _this = this;
import Lenis from 'lenis';
/* eslint-disable import/no-unresolved */
import { getElement, getElements } from '../helpers/functions';
/* eslint-enable import/no-unresolved */

import { baseElements } from '../helpers/constants';
const {
  $header
} = baseElements;

/**
 * Singleton instance of Lenis scroll
 * Ensures only one scroll instance exists throughout the application
 * @type {Lenis|null}
 */
let scrollInstance = null;

/**
 * Initializes the smooth scroll functionality
 * @param {Object} options - Configuration options for Lenis
 * @param {boolean} [options.autoRaf=true] - Whether to auto-handle requestAnimationFrame
 * @param {boolean} [options.smoothWheel=true] - Enable smooth scrolling for mouse wheel
 * @returns {Lenis} The Lenis scroll instance
 */
export const initScroll = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const scrollToHash = hash => {
    if (!hash) return;
    const target = getElement(hash);
    if (target) {
      scrollInstance.scrollTo(target, {
        offset: -$header.offsetHeight
      });
    }
  };
  const handleHashChange = e => {
    e.preventDefault();
    const newHash = window.location.hash;
    if (newHash) {
      scrollToHash(newHash);
    } else {
      scrollInstance.scrollTo(0);
    }
  };
  const debounce = (func, delay) => {
    let timeoutId;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(_this, args), delay);
    };
  };
  if (!scrollInstance) {
    // Initialize Lenis with default and custom options
    scrollInstance = new Lenis({
      autoRaf: true,
      smoothWheel: true,
      ...options
    });
    const resizeObserver = new ResizeObserver(debounce(() => scrollInstance.resize(), 250));
    resizeObserver.observe(document.body);

    // Handle all anchor links on the page
    getElements('a[href^="#"]:not([href="#"])').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const targetId = link.getAttribute('href');
        if (targetId !== '#') {
          window.history.pushState(null, '', targetId);
        }
        scrollToHash(targetId);
      });
    });
    if (window.location.hash) {
      window.scrollTo(0, 0);
      setTimeout(() => {
        scrollToHash(window.location.hash);
      }, 100);
    }
  }
  window.addEventListener('hashchange', handleHashChange.bind(_this));
  return scrollInstance;
};

/**
 * Gets the current Lenis scroll instance
 * Useful for accessing scroll functionality from other components
 * @returns {Lenis|null} The current Lenis instance or null if not initialized
 */
export const getScroll = () => initScroll();